// extracted by mini-css-extract-plugin
export default {"agencyReviewsMobile":"agencyReviewsMobile_VUwiQ","slider":"slider_AzuUH","buttons":"buttons_vpxjk","description":"description_VvUYe"};